<template>
  <div>
    <div v-if="loading" class="loading">Loading poll...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
<ProposalDetail
      v-else
      :proposal="poll"
      :requireVoterInfo="true"
      @close="handleClose"
      @vote="refresh"
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { governanceService } from '@/services/governanceService'
import ProposalDetail from '@/components/governance/ProposalDetail.vue'

export default {
  name: 'PublicPollView',
  components: { ProposalDetail },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const loading = ref(true)
    const error = ref('')
    const poll = ref(null)

    const fetchPoll = async () => {
      loading.value = true
      error.value = ''
      try {
        const id = route.params.id
        const data = await governanceService.getPublicPoll(id)
        poll.value = data
      } catch (e) {
        error.value = e?.message || 'Failed to load poll'
      } finally {
        loading.value = false
      }
    }

    const handleClose = () => {
      if (window.history.length > 1) router.back()
      else router.push('/governance')
    }

    const refresh = () => fetchPoll()

    onMounted(fetchPoll)

    return { loading, error, poll, handleClose, refresh }
  }
}
</script>

<style scoped>
.loading { color: #6b7280; padding: 24px; text-align: center; }
.error { color: #b91c1c; background: #fee2e2; border: 1px solid #fecaca; padding: 8px; border-radius: 4px; margin: 16px; text-align: center; }
</style>
